import { render, staticRenderFns } from "./Bracket8.vue?vue&type=template&id=05136720&scoped=true&"
import script from "./Bracket8.vue?vue&type=script&lang=js&"
export * from "./Bracket8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05136720",
  null
  
)

export default component.exports